import { type IconsType, library } from '../components/shared'
import { ColorsV2 } from '../design-system/colors_v2'

export const isValidIconType = (value: string): value is IconsType => {
  return value in library
}
export const isValidColorType = (value: ColorsV2): boolean => {
  return Object.values(ColorsV2).includes(value);
}
